module.exports = __webpack_public_path__ + "static/pic81-63e9086366ab2e7f7aa5b80dc695d5e1.jpg";